/* eslint-disable class-methods-use-this */
import React from 'react';
import { wrapComponent } from 'utils/framework';
import BaseClass from 'components/BaseClass';
import Dropdown from 'components/Dropdown/Dropdown';
import StoresContent from 'components/Header/StoresContent/StoresContent';
import { Icon } from 'components/ui';
import {
    colors, space, lineHeights, fontWeights
} from 'style/config';
import localeUtils from 'utils/LanguageLocale';
import { isGenAINewUIEnabledWithRCPS } from 'ai/utils/aiBeautyChat';
import HeaderEN from 'components/Header/locales/Header_en_US';
import HeaderFR from 'components/Header/locales/Header_fr_CA';

const { getLocalisedDataFromResource } = localeUtils;
const getText = getLocalisedDataFromResource(HeaderEN, HeaderFR);

class ServicesAndEventsDrop extends BaseClass {
    state = {
        isOpen: false
    };

    render() {
        const { isOpen } = this.state;
        const { items, stacked } = this.props;
        const isGenAINewUIEnabled = isGenAINewUIEnabledWithRCPS();

        return (
            <Dropdown
                id='services_and_events_drop'
                hasMaxHeight={true}
                onTrigger={(e, isDropdownOpen) => {
                    this.setState({
                        isOpen: isDropdownOpen
                    });
                }}
            >
                <Dropdown.Trigger
                    display='flex'
                    flexDirection={stacked ? 'column' : 'row'}
                    alignItems='center'
                    justifyContent={stacked ? 'center' : null}
                    paddingX={4}
                    height='100%'
                    data-at={Sephora.debug.dataAt('services_and_events_header')}
                >
                    <Icon
                        name={isOpen ? 'reservationsActive' : 'reservations'}
                        size={24}
                        marginRight={stacked ? 0 : 3}
                        marginBottom={stacked ? 1 : 0}
                        style={{ opacity: !isOpen ? 0.6 : null }}
                    />
                    <span
                        css={[isOpen && styles.triggerLabelActive, stacked ? styles.stackedLabel : isGenAINewUIEnabled && styles.smallTriggerLabel]}
                        children={getText(stacked ? 'services' : 'servicesAndEvents')}
                    />
                </Dropdown.Trigger>
                <Dropdown.Menu
                    width={this.props.dropWidth}
                    align='center'
                    paddingY={4}
                    data-at={Sephora.debug.dataAt('services_and_events_flyout_menu')}
                >
                    <StoresContent
                        items={items}
                        renderServicesAndEventsOnly
                    />
                </Dropdown.Menu>
            </Dropdown>
        );
    }
}

const styles = {
    triggerLabel: {
        marginLeft: space[3]
    },
    triggerLabelActive: {
        boxShadow: `0 2px 0 0 ${colors.black}`
    },
    smallTriggerLabel: {
        width: 58,
        lineHeight: lineHeights.tight
    },
    stackedLabel: {
        maxWidth: 72,
        overflow: 'hidden',
        textAlign: 'center',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        lineHeight: lineHeights.tight,
        fontWeight: fontWeights.bold
    }
};

export default wrapComponent(ServicesAndEventsDrop, 'ServicesAndEventsDrop');
